<template>
	<div class="thread-line-container">
		<div v-if="topDots" class="thread-line-dots top" />
		<div
			class="thread-line"
			:class="{
				start: isStart,
				quote: hasQuote,
				'top-dots': topDots,
				'bottom-dots': bottomDots,
				'with-button': hasButton,
			}"
		/>
		<div v-if="bottomDots" class="thread-line-dots bottom" />
		<div v-if="showBackdrop" class="hover-backdrop" />
	</div>
</template>

<script>
export default {
	name: 'ThreadLine',
	props: [
		'isStart',
		'topDots',
		'bottomDots',
		'hasQuote',
		'showBackdrop',
		'hasButton',
	],
}
</script>

<style lang="scss" scoped>
// NOTE: This whole thing is super fragile. There are
// lots of magic numbers for top/bottom values that
// account for the various scenarios when dots/buttons
// should appear. Sorry in advance for the future headaches
// and maintenance nightmares. 🙏

@import 'src/sass/variables';
$left-offset: 33px;

$top-offset: 44px;
$bottom-offset: 22px;
$button-offset: 4px;

.thread-line {
	position: absolute;
	z-index: 1;
	top: 0;
	bottom: 0;
	left: $left-offset;
	width: 2px;
	background: var(--teal-300);
	&.start {
		top: $top-offset;
	}
	&.quote {
		top: -8px;
	}
	&.top-dots {
		top: $top-offset;
	}
	&.top-dots.bottom-dots {
		top: $top-offset;
	}
	&.with-button {
		bottom: 2px;
	}
	&.with-button.bottom-dots {
		bottom: $bottom-offset;
	}
}
.thread-line-dots {
	$four-dots: 16px;
	$three-dots: 12px;
	position: absolute;
	z-index: 1;
	left: $left-offset;
	width: 2px;
	border-radius: 2px;
	background: url('/images/pronto/thread-dot.svg');
	background-size: 2px 4px;
	background-repeat: repeat-y;
	&.top {
		top: -10px;
		height: $four-dots;
	}
	&.bottom {
		bottom: $button-offset;
		height: $four-dots;
	}
}

.hover-backdrop {
	position: absolute;
	z-index: 0;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	overflow: hidden;
	border-radius: 10px;
	background: var(--neutral-100);
}
</style>
<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.message-wrapper {
		.hover-backdrop {
			background: var(--neutral-0);
		}
	}
}
</style>
